import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    email: '',
    store_id: ''
  },
  mutations: {
    setEmail(state, email) {
      state.email = email
    },
    setStoreId(state, store_id) {
      state.store_id = store_id
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    getEmail(state) {
      return state.email
    },
    getStoreId(state) {
      return state.store_id
    }
  },
  plugins: [createPersistedState({ storage: window.localStorage })]
})
